import { apiClient } from './client';
import type { DocumentApproval } from '../types';

const skipAuthRedirect = { skipAuthRedirect: true } as any;

const isAuthFailure = (error: unknown): boolean => {
  const status = (error as any)?.response?.status;
  return status === 401 || status === 403;
};

export const getMyDocumentApprovals = async (): Promise<DocumentApproval[]> => {
  const { data } = await apiClient.get<DocumentApproval[]>('/document-approvals/worker/my');
  return data;
};

export const getDocumentApproval = async (id: string): Promise<DocumentApproval> => {
  if (localStorage.getItem('accessToken')) {
    try {
      const { data } = await apiClient.get<DocumentApproval>(`/document-approvals/worker/my/${id}`, skipAuthRedirect);
      return data;
    } catch (error) {
      if (!isAuthFailure(error)) throw error;
    }
  }

  const { data } = await apiClient.get<DocumentApproval>(`/document-approvals/public/${id}`, skipAuthRedirect);
  return data;
};

export const approveDocument = async (id: string, signatureData?: string): Promise<DocumentApproval> => {
  if (localStorage.getItem('accessToken')) {
    try {
      const { data } = await apiClient.post<DocumentApproval>(
        `/document-approvals/worker/my/${id}/approve`,
        { signatureData },
        skipAuthRedirect,
      );
      return data;
    } catch (error) {
      if (!isAuthFailure(error)) throw error;
    }
  }

  const { data } = await apiClient.post<DocumentApproval>(
    `/document-approvals/public/${id}/approve`,
    { signatureData },
    skipAuthRedirect,
  );
  return data;
};

export const rejectDocument = async (id: string, reason: string): Promise<DocumentApproval> => {
  if (localStorage.getItem('accessToken')) {
    try {
      const { data } = await apiClient.post<DocumentApproval>(
        `/document-approvals/worker/my/${id}/reject`,
        { reason },
        skipAuthRedirect,
      );
      return data;
    } catch (error) {
      if (!isAuthFailure(error)) throw error;
    }
  }

  const { data } = await apiClient.post<DocumentApproval>(
    `/document-approvals/public/${id}/reject`,
    { reason },
    skipAuthRedirect,
  );
  return data;
};

export const trackDocumentApprovalOpen = async (id: string): Promise<void> => {
  if (localStorage.getItem('accessToken')) {
    try {
      await apiClient.post(`/document-approvals/worker/my/${id}/opened`, undefined, skipAuthRedirect);
      return;
    } catch (error) {
      if (!isAuthFailure(error)) throw error;
    }
  }

  await apiClient.post(`/document-approvals/public/${id}/opened`, undefined, skipAuthRedirect);
};
